/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  FundTenantGuaranteeOptions,
  FundTenantGuaranteeResponses,
} from '../types/FundTenantGuarantee'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Creates a guarantee-fund ledger entry with tx_kind DEPOSIT.
 * @summary Add funds to the guarantee fund for a tenant.
 * {@link /v1/tenants/:tenant_id/fund_guarantee}
 */
export function fundTenantGuarantee<ThrowOnError extends boolean = true>(
  options: Options<FundTenantGuaranteeOptions, ThrowOnError>,
): Unwrappable<RequestResult<FundTenantGuaranteeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/tenants/{tenant_id}/fund_guarantee',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<FundTenantGuaranteeResponses, ThrowOnError>>,
  )
}
